export default __webpack_public_path__ + "static/media/treeify.af11f1bc.png";